<template>
  <v-container fluid class="tabs-content__container">
    <v-row class="ma-0">
      <v-col cols="12">
        <h1>Audiences
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="blue-grey lighten-1" style="vertical-align:text-top; margin-top:3px">info</v-icon>
            </template>
            <span>Select the audience for your campaign</span>
          </v-tooltip>
        </h1>
        <audience-path-selector
          @selectCreativePath="selectCreativePath"
          :activePath="activeComponent"
        />
      </v-col>
      <v-col cols="12">
        <transition name="component-fade" mode="out-in">
          <component
            :is="activeComponent"
            :files="files"
            :campaign="campaign"
            @addFile="addFile"
            @removeFile="removeAudience"
            @closeDialog="closeDialog"
            @cancelStepper="filesTableActive = true"
            @setTargeting="setTargeting"
            @setCampaignProperty="setCampaignProperty"
            @showAudiencesTable="showAudiencesTable"
          />
        </transition>
      </v-col>
    </v-row>
    <div class="tabs-content__container-action">
      <v-row>
          <v-btn
            v-if="showButtons"
            @click="previousPage"
          >Previous</v-btn>
        <v-spacer />
          <v-btn
            v-if="showButtons"
            color="primary"
            :disabled="!next"
            @click="nextPage"
          >
            Next
          </v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import AudiencePathSelector from './AudiencePathSelector.vue'
import RecommendedAudiencesTable from './RecommendedAudiencesTable.vue'
import SavedAudiencesTable from './SavedAudiencesTable.vue'
import UploadStepper from './upload-stepper/Index'
import VoterList from './voter-list/Index'
import FbAudience from './fb-audience/Index'
import Rem from './rem/Index'
import Lookalike from './lookalike/Index'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'audience',
  components: {
    AudiencePathSelector,
    RecommendedAudiencesTable,
    SavedAudiencesTable,
    UploadStepper,
    VoterList,
    FbAudience,
    Rem,
    Lookalike
  },
  data () {
    return {
      dialog: false,
      filesTableActive: false,
      next: false,
      activeComponent: 'saved-audiences-table'
    }
  },
  props: {
    campaign: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      files: 'getAudiences'
    }),
    showButtons () {
      const forbidenPaths = ['voter-list']
      return !forbidenPaths.find(p => p === this.activeComponent)
    }
  },
  methods: {
    setCampaignProperty (property, value) {
      this.$emit('setCampaignProperty', property, value)
    },
    closeDialog () {
      this.activeComponent = 'saved-audiences-table'
    },
    showAudiencesTable () {
      this.activeComponent = 'saved-audiences-table'
    },
    selectCreativePath (path) {
      this.activeComponent = path
    },
    addFile (file) {
      this.filesTableActive = true
      Object.assign(file, {id: this.files.length + 1})
      this.addAudience(file)
    },
    removeFile (id) {
      this.files = this.files.filter(file => file.id !== id)
    },
    nextPage () {
      this.$emit('next')
    },
    previousPage () {
      this.$emit('previous')
    },
    setTargeting (targeting, status) {
      this.next = status
      this.$emit('setTargeting', targeting)
    },
    ...mapActions([
      'addAudience',
      'removeAudience'
    ])
  }
}
</script>
<style>
  .component-fade-enter-active, .component-fade-leave-active {
      transition: opacity .2s ease;
  }
  .component-fade-enter, .component-fade-leave-to
      /* .component-fade-leave-active below version 2.1.8 */ {
      opacity: 0;
  }
</style>
